const StoreData=[
    {
        ID:1,
        Header:'Gandhinagar',
        Location:'House No. 1-1-566/A/2, HDFC Bank Lane, Golconda X Roads, near Post Office, Gandhinagar, Musheerabad, Hyderabad, Telangana 500020, India',
        Name:'Nerlakanti Ramesh Kumar',
        Phone:'9848118844',
        methods:'gs1',
        Link:'https://maps.app.goo.gl/Z4zgjyNEoE7BSxgq6'
    },
    {
        ID:2,
        Header:'Padmaraonagar',
        Location:'6-1-334/14/C, beside NTR Statue, Walker Town, Padmarao Nagar, Secunderabad, Telangana 500025, India',
        Name:'Rajeshwar Rao, Naseer',
        Phone:'9652346163, 9849691078, 9866218374',
        Link:'https://maps.app.goo.gl/4TEShdB3TKgejkXt8'
    },
    {
        ID:3,
        Header:'Yousufguda',
        Location:'3-250/1/C, A block, Sri Krishna Nagar, Krishna Nagar, Yousufguda, Hyderabad, Telangana 500045, India',
        Name:'Nerlakanti Radha',
        Phone:'9848264447, 7416064544, 6281294522',
        Link:'https://maps.app.goo.gl/A5puXgfKR6XL6c4B9'
    },
    {
        ID:4,
        Header:'Alwal',
        Location:'H No 1-23-515, Plot No 62, Bhoodevi Nagar, Alwal, Hyderabad - 500010 (Alwal, Secendrabad)',
        Name:'Nerlakanti Radha',
        Phone:'9848264447',
        Link:'https://maps.app.goo.gl/Jz7iRigzyxCcAFo96'
    },
    {
        ID:5,
        Header:'Pothireddypally, Sangareddy',
        Location:'Shop No. 8,Coral Castle Complex, X Road, Sangareddy,, Pothreddipalle, Telangana 502295, India',
        Name:'Harish',
        Phone:'8978986411',
        Link:'https://maps.app.goo.gl/MygpvZLCZDEfe1HV6'
    },
    {
        ID:6,
        Header:'Sangareddy, Opp Court',
        Location:'SH 17, Habeeb Nagar, Sangareddy, Telangana 502001, India',
        Name:'Tatikonda Shylaja',
        Phone:'8341562587',
        Link:'https://maps.app.goo.gl/afDP2Fmj8UnfcieN8'
    },
    


    
]
export default StoreData;